import { render, staticRenderFns } from "./PaymentStatusPage.vue?vue&type=template&id=8c1caa64&scoped=true&"
import script from "./PaymentStatusPage.vue?vue&type=script&lang=js&"
export * from "./PaymentStatusPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c1caa64",
  null
  
)

export default component.exports